const businessPageImagePaths = {
  heroSection: {
    banner: require('/public/images/Business/business-banner.svg').default,
  },
  dropDownSection: {
    clock: require('/public/images/Business/business-dropdown-icon.png')
      .default,
    business: require('/public/images/Business/business.webp').default,
    mainImage1: require('/public/images/Business/company-crafted-pathways.webp')
      .default,
    mainImage2: require('/public/images/Business/roi-driven-efficiency.webp')
      .default,
    mainImage3:
      require('/public/images/Business/seamless-ecosystem-integration.webp')
        .default,
    mainImage4: require('/public/images/Business/actionable-data-insights.webp')
      .default,
  },
  pathwayIcons: {
    icon1: require('/public/images/Business/company-crafted-pathways.svg')
      .default,
    icon2:
      require('/public/images/Business/seamless-eco-system-integration.svg')
        .default,
    icon3: require('/public/images/Business/data-insights.svg').default,
    icon4: require('/public/images/Business/roi-driven-efficiency.svg').default,
  },
  dropDownSectionOne: {
    forStudents: {
      icon1: require('/public/images/Business/job-ready-talent.svg').default,
      icon2: require('/public/images/Business/unified-talent-ecosystem.svg')
        .default,
      icon3: require('/public/images/Business/standardised-profiles.svg')
        .default,
      icon4: require('/public/images/Business/marquee-employer.svg').default,
    },
  },
  readyToGetStarted: {
    mainImage:
      require('/public/images/Business/businesses-ready-get-started-illustration.svg')
        .default,
  },
  BusinessAdvantagesData: {
    icon1: require('/public/images/Business/advantages-icon-1.svg').default,
    icon2: require('/public/images/Business/advantages-icon-2.svg').default,
    icon3: require('/public/images/Business/advantages-icon-3.svg').default,
    icon4: require('/public/images/Business/advantages-icon-4.svg').default,
    icon5: require('/public/images/Business/advantages-icon-5.svg').default,
    icon6: require('/public/images/Business/advantages-icon-6.svg').default,
    icon7: require('/public/images/Business/advantages-icon-7.svg').default,
  },
};

export default businessPageImagePaths;
